/* @jsx jsx */
import React, { useEffect, useRef } from 'react';
import { jsx } from '@emotion/react';
import { suggestionListItemStyles, suggestionIconStyles, suggestionLabelStyles, suggestionButtonStyles, enterIconStyles, tellAILabelStyles } from './styles';
import Enter from '../../assets/Enter';
import { LogoSvg } from '../../assets/Logo';
const ensureElementIsVisibleInScrollContainer = listItem => {
  var _listItem$offsetParen;
  // ensure the structure of suggestions li element > ul (position relative) > scrollable div (overflow auto)
  const scrollContainer = (_listItem$offsetParen = listItem.offsetParent) === null || _listItem$offsetParen === void 0 ? void 0 : _listItem$offsetParen.parentElement;
  if (!scrollContainer || scrollContainer.tagName !== 'DIV') {
    return;
  }
  const scrollContainerRect = scrollContainer.getBoundingClientRect();
  const itemRect = listItem.getBoundingClientRect();

  // if highlighted item is above/below the current scroll viewport
  const itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
  if (itemNotVisible) {
    // Can't use item.scrollIntoView() because it moves the whole page too
    scrollContainer.scrollTo({
      top: listItem.offsetTop,
      behavior: 'smooth'
    });
  }
};
export const ListItem = ({
  suggestion,
  customLabel,
  highlighted,
  setSuggestion
}) => {
  const listItemRef = useRef(null);
  const updateSuggestion = React.useCallback(eventName => {
    if (setSuggestion) {
      setSuggestion(suggestion, eventName);
    }
  }, [setSuggestion, suggestion]);
  const onFocus = React.useCallback(() => {
    updateSuggestion('focus');
    suggestion.onSuggestionFocused();
  }, [updateSuggestion, suggestion]);
  const onMouseMove = React.useCallback(() => {
    updateSuggestion('mousemove');
  }, [updateSuggestion]);
  useEffect(() => {
    // If the item is highlighted and not hovered, scroll it into view
    if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) {
      ensureElementIsVisibleInScrollContainer(listItemRef.current);
    }
  }, [listItemRef, highlighted]);
  return jsx("li", {
    css: suggestionListItemStyles,
    ref: listItemRef
  }, jsx("button", {
    css: suggestionButtonStyles,
    type: "button",
    onClick: suggestion.onSelect,
    onMouseMove: onMouseMove,
    "data-testid": customLabel ? `tell-ai` : suggestion.label,
    "data-highlighted": highlighted,
    onFocus: onFocus
  }, suggestion.value !== 'tell-ai' && jsx("span", {
    css: suggestionIconStyles
  }, suggestion.icon || jsx(LogoSvg, {
    className: "default-icon",
    alt: ''
  })), jsx("span", {
    css: suggestionLabelStyles
  }, !customLabel ? suggestion.label : jsx("span", null, jsx("span", {
    css: tellAILabelStyles
  }, customLabel), " \"", suggestion.label, "\"")), jsx("span", {
    className: "enterIcon",
    css: enterIconStyles
  }, jsx(Enter, null))));
};